module.exports = __webpack_public_path__ + "img/bb.a0a50165.svg";